import React from 'react';
import PropTypes from 'prop-types';

import { BorderRadius, Colors, FontSizes } from '../Theme';

const ButtonToggle = ({ activeLabel, inactiveLabel, onChange, selected }) => {
  const styles = {
    component: Object.assign(
      {},
      {
        display: 'inline-block',
        borderRadius: BorderRadius.DEFAULT,
        overflow: 'hidden',
        backgroundColor: '#fff',
        color: Colors.GRAY.hex,
        fontSize: FontSizes.MEDIUM,
        position: 'relative',
        cursor: 'pointer'
      },
      this.props.style
    ),
    button: {
      padding: '9px 20px 8px',
      display: 'inline-block',
      border: '1px solid rgba(0,0,0,0.15)',
      lineHeight: '18px'
    },
    yes: {
      backgroundColor: Colors.GREEN.hex,
      color: '#fff'
    },
    no: {
      backgroundColor: Colors.RED.hex,
      color: '#fff'
    }
  };

  return (
    <div style={styles.component}>
      <div
        onClick={onChange.bind(null, true)}
        style={Object.assign({}, styles.button, selected && styles.yes)}
      >
        {activeLabel || 'On'}
      </div>
      <div
        onClick={onChange.bind(null, false)}
        style={Object.assign({}, styles.button, !selected && styles.no)}
      >
        {inactiveLabel || 'Off'}
      </div>
    </div>
  );
};

ButtonToggle.propTypes = {
  activeLabel: PropTypes.string,
  inactiveLabel: PropTypes.string,
  onChange: PropTypes.func,
  selected: PropTypes.bool
};

export default ButtonToggle;
